module.exports = __webpack_public_path__ + "img/6517.2e99e2ef.jpg";